import React from 'react';

class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary] Error capturado en módulo:', error);
    console.error('[ErrorBoundary] Component stack:', info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          minHeight: '320px',
          gap: '12px',
          padding: '40px 24px',
          textAlign: 'center',
          color: '#374151',
          fontFamily: 'inherit',
        }}>
          <div style={{ fontSize: '48px', lineHeight: 1 }}>⚠️</div>
          <p style={{ fontSize: '18px', fontWeight: 600, margin: 0 }}>
            Algo salió mal en este módulo
          </p>
          {this.state.error?.message && (
            <p style={{
              fontSize: '13px',
              color: '#6B7280',
              margin: 0,
              maxWidth: '420px',
              wordBreak: 'break-word',
            }}>
              {this.state.error.message}
            </p>
          )}
          <button
            onClick={() => this.setState({ hasError: false, error: null })}
            style={{
              marginTop: '8px',
              padding: '10px 28px',
              background: 'var(--color-state-info-solid)',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: 600,
              cursor: 'pointer',
              letterSpacing: '0.01em',
            }}
          >
            Recargar módulo
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
